<template>
  <div>
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <div v-if="!loading">
      <div class="book-part">
        <obs-basic></obs-basic>
      </div>
      <div class="book-part">
        <obs-contact></obs-contact>
      </div>
      <div class="book-part">
        <book-match></book-match>
      </div>
      <div class="book-part">
        <book-pick></book-pick>
      </div>
      <div class="book-part">
        <additional-charge></additional-charge>
      </div>
      <div class="book-part">
        <book-note></book-note>
      </div>
      <div class="book-part">
        <book-logs></book-logs>
      </div>
    </div>
  </div>
</template>

<script>
// import pick from 'lodash.pick'
import ObsBasic from './components/basic/BookBasicMain'
import ObsContact from './components/basic/contact/ContactInfo'
import FooterToolBar from '@/components/FooterToolbar'
import AdditionalCharge from './components/charges/BookAdditionalChargeMain'
import BookLogs from './components/logs/BookLogsMain'
import BookNote from './components/note/BookNoteMain'
import bookMatch from './components/basic/bookmatch/BookMatchMain'
import BookPick from './components/pickupsendoff/BookPickSendMain'

export default {
  name: 'BookEdit',
  components: {
    FooterToolBar,
    ObsBasic,
    ObsContact,
    BookLogs,
    BookNote,
    BookPick,
    AdditionalCharge,
    bookMatch,
    
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      // 加载中
      loading: true
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      if (data === '') {
        // 新增
        //formData = { 'id': null, 'code': null, 'nameEnUs': null, 'nameZhTw': null, 'nameZhCn': null, 'cityId': null }
      }
      this.loading = false
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      e.preventDefault()
    }
  }
}
</script>
<style lang="less" scoped>

</style>